// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__HR7m1","paragraph":"style_paragraph__NMIkt","isBold":"style_isBold__2Ex7s","link":"style_link__qfS_j"};